export const EMAIL_REGEX = '^(.+)@(\\S+)$'
